export const queryParamsKey = {
  page: "page",
  search: "search",
  sort: "ordering",
  userRole: "role",
};

export enum sortDirection {
  asc = "ascending",
  desc = "descending",
  ascPrefix = "",
  descPrefix = "-",
}

export type TSortDirection = "ascending" | "descending" | null;

export interface TableHeaderParam {
  name: string;
  orderingKey?: string;
  [key: string]: any;
}

export const sortArrowActiveNameClass = "sort-active";
